import type { ReactNode } from 'react';
import { MagnifyingGlass } from '../../../design-system/icons';
import { Input } from '../../../components/ui/input';

/**
 * Figma: search field + "Sort by" + "Filters" controls that sit beside the pills
 * on a roster screen. Search is now controlled (query/onQueryChange). Sort and
 * Filters are commented out until BE params are wired.
 */
export function RosterSearchSort({
  placeholder = 'Search creators…',
  query = '',
  onQueryChange,
  columnsMenu,
}: {
  placeholder?: string;
  query?: string;
  onQueryChange?: (q: string) => void;
  /** Optional Columns visibility dropdown, rendered beside the search box. */
  columnsMenu?: ReactNode;
}) {
  return (
    <div className="flex items-center gap-3">
      <div className="relative w-80">
        <MagnifyingGlass size={16} className="absolute top-1/2 left-3 -translate-y-1/2 text-muted-foreground" />
        <Input
          placeholder={placeholder}
          className="h-10 rounded-lg border-border bg-card pl-9"
          value={query}
          onChange={onQueryChange ? (e) => onQueryChange(e.target.value) : undefined}
        />
      </div>
      {columnsMenu}
      {/* Sort by — commented out until BE sort params are wired.
      <button type="button" className="flex h-10 shrink-0 items-center gap-2 rounded-full border border-border bg-card px-3.5 text-body-sm-medium text-foreground transition-colors hover:bg-muted">
        <CalendarBlank size={16} className="text-foreground" /> Sort by <CaretDown size={14} className="text-foreground" />
      </button>
      */}
      {/* Filters — commented out until BE filter params are wired.
      <button type="button" className="flex h-10 shrink-0 items-center gap-2 rounded-full border border-border bg-card px-3.5 text-body-sm-medium text-foreground transition-colors hover:bg-muted">
        <SlidersHorizontal size={16} className="text-foreground" /> Filters
      </button>
      */}
    </div>
  );
}
